import { TeamOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { observer } from "mobx-react-lite";
import {  useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import AccountInfoBlock from '../components/AccountInfo/AccountInfoBlock';
import TableAccountInfo from '../components/TableAccountInfo';
import { useStore } from '../../../stores/root-store-context';
import { ModalFileViewer } from "../../ModalFileViewer/ModalFileViewer";
import Spinner from 'Components/Spinner/Spiner';
import Headers from '../../../../../../../../redux/Actions/Headers/Header';
import Card from 'Components/Card/Card';
import '../../ric.css';

const AccountInfo =  observer(() => {
    const dispatch = useDispatch();
     const {ricStore,modalViewerStore,applicationStore} = useStore();
    const { id } = useParams<string>();
    useEffect(()=>{
if(id){
    ricStore.setAccount(id);
}
    },[id])
    useEffect(() => {
      if (!applicationStore.userEmployee) {
        applicationStore.loadProperties();
      }
    }, []);
    useEffect(() => {
        if (ricStore.selectedAccount) {
          ricStore.getRicInfo().catch(console.log);
        } else {
          ricStore.setShowRicInfo(false);
        }
      }, [ricStore.selectedAccount]);
      useEffect(() => {
        dispatch(
          Headers.setHeader({
            title: "RIC - Resident Information Console",
            subtitle: "Search and manage resident information across your communities.",
            icon: <TeamOutlined />,
          })
        );
        return () => {
          dispatch(Headers.resetHeader());
        };
      }, [dispatch]);
  return (
    <div className="ric ric-account-detail ric-account">
        {( ricStore?.isLoadingApp || ricStore.isLoadingRicData ||applicationStore.isLoading) && <Spinner/>}
    <div className="ric-account__section">
      <AccountInfoBlock />
    </div>
    <Card className="ric-card" style={{ paddingTop: 6 }}>
      <TableAccountInfo />
    </Card>
    <ModalFileViewer
            isOpenModal={modalViewerStore.isOpenModal}
            dismissModal={modalViewerStore.dissmissModal}
            urlModal={modalViewerStore.urlModal}
            isImage={modalViewerStore.isLocalFileForIframe}
            documentName={modalViewerStore.documentName}
          />
  </div>
  );
});

export default AccountInfo;
